import { h } from 'preact';
import * as BaseComp from 'components/bolt/signUpForm/signUpForm.js';
import Store from 'store/store';
import 'store/bolt/signUpBanner';
import { joinClasses, accessNested, loadScript } from 'utils/utils';
import s from 'components/bolt/signUpForm/signUpForm.sss';

const APP_ID = 'app_6pCHNfK3NjieXiPKn5Qds2qizHYzKfgI87W2rjQEhsc';
const CLIENT_KEY_DEV = 'dev_DcHhqdw8Nz8SteYn8WKA7tH5DdFJO3Nk4FjzuIlsWRI';
const CLIENT_KEY_PROD = 'prod_uMQzABqZZ8wv8D6WVW2vrunJbnaDm9f6qsqZSMA1YNQ';

export default class SignUpForm extends BaseComp.default {
	constructor(props) {
		super(props);

		this.formType = accessNested(Store.get(), 'appData.options.formEmbeds.signUp.formType', {});
		this.useLeanplum = this.formType === 'leanplum';
		this.FormTag = this.useLeanplum ? 'div' : 'form';

		this.state = {
			email: '',
			error: null
		};

		this.leanplumSubscribe = this.leanplumSubscribe.bind(this);
		this.handleResponse = this.handleResponse.bind(this);
		this.subscribe = this.subscribe.bind(this);
	}

	async componentDidMount() {
		super.componentDidMount();

		await loadScript('https://cdn.jsdelivr.net/npm/leanplum-sdk@1.9.0/dist/leanplum.min.js');

		if (__IS_LOCAL__) {
			window.Leanplum.setAppIdForDevelopmentMode(APP_ID, CLIENT_KEY_DEV);
		} else {
			window.Leanplum.setAppIdForProductionMode(APP_ID, CLIENT_KEY_PROD);
		}
		window.Leanplum.setApiPath('https://api.leanplum.com/api');
		window.Leanplum.addStartResponseHandler(this.handleResponse);
	}

	componentWillUnmount() {
		super.componentWillUnmount();

		window.Leanplum.stop();
	}

	leanplumSubscribe( email) {
		window.Leanplum.start({
			'EmailAddress': email,
			'Email Address': email,
			'Source': Store.get().appData?.copy?.baseCopy.$META_TITLE,
			'unsubscribeChannels': []
		});
	}

	subscribe() {
		const { email } = this.state;

		if (email && email.match(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
			this.leanplumSubscribe(email);
		} else {
			this.setState({
				email: '',
				error: 'Please enter a valid email'
			});
		}
	}

	handleResponse(success) {
		if (success) {
			this.closeBanner({}, 'subscribed');
		} else {
			this.setState({
				email: '',
				error: 'An error occurred. Please try again later.'
			});
		}
	}

	getForm() {
		let form;
		const { data } = this.props;
		const { error } = this.state;
		const btnData = data.button || {};

		if (this.useLeanplum) {
			const submitBtn = (
				<input
					type="submit"
					class={joinClasses(s.button, s.submitFormBtn)}
					value={btnData.label}
					name="subscribe"
					ariaLabel={btnData.ariaLabel}
					onClick={(e) => this.subscribe(e)}
				/>
			);

			form = (
				<div class={joinClasses(s.inputContainer, s.emailInputContainer)} ref={ref => this.$inputContainer = ref}>
					<input
						type="email" class={s.email}
						value={this.state.email}
						onChange={(e) => this.setState({ email: e.target.value })}
						name="EMAIL"
						id="EMAIL"
						placeholder={error || data.emailPlaceholder || 'Email address'}
						required
					/>
					<input type="text" class={s.antiBot} name={'b_' + this.u + '_' + this.id} tabindex="-1" value="" aria-hidden="true" />
					{submitBtn}
				</div>
			);

			return form;
		} else {
			return super.getForm();
		}
	}
}
